<template>

  <vx-card
    :title="$t('class-over-view.virtual-class')"
    class="p-1"
    title-color="primary"
  >

    <template slot="actions">
      <div class="flex justify-end">
        <vs-button
          @click="navigateToVirtualClassExample"
          class="mr-2 shadow-lg card-button"
          type="gradient" color="success">
          <span>{{ $t('teacher-dash-board.virtual-class-example') }}</span>
        </vs-button>
      </div>
    </template>

    <ul class="vx-timeline">
        <li :key="unit.id" v-for="unit in courseOutlineUnits">
          <div class="timeline-icon bg-grey">
            <feather-icon icon="PlayIcon" svgClasses="text-white stroke-current w-5 h-5"/>
          </div>
          <div class="timeline-info">
            <p class="font-semibold text-l text-primary">{{ $t('vdo-live-set-topic.edit-title')}} {{ unit.seq }}</p>
            <p class="font-semibold text-xl pb-4 ">{{ unit.nameLocal }}</p>

            <div class="flex justify-between">
              <vs-chip class="cursor-pointer" color="primary" transparent
                       closable close-icon="touch_app"
                       @click="openPopUpClick(unit.descriptionLocal, $t('class-over-view.content-brief'))">
                {{ $t('class-over-view.content-brief') }}
              </vs-chip>
              <vs-chip class="cursor-pointer" color="primary" transparent
                       closable close-icon="touch_app"
                       @click="openPopUpClick(unit.unitObjective, $t('class-over-view.objective'))">
                {{ $t('class-over-view.objective') }}
              </vs-chip>
              <vs-chip class="cursor-pointer" color="primary" transparent
                       closable close-icon="touch_app"
                       @click="openPopUpClick(unit.unitAgenda, $t('class-over-view.agenda'))">
                {{ $t('class-over-view.agenda') }}
              </vs-chip>
              <vs-chip class="cursor-pointer" color="primary" transparent
                       closable close-icon="touch_app"
                       @click="openPopUpClick(unit.unitReference, $t('class-over-view.reference'))">
                {{ $t('class-over-view.reference') }}
              </vs-chip>

            </div>
          </div>
          <div class="flex flex-row justify-between px-0 pb-4 pr-4 mt-4">
            <p class="text-center">
                        <span class="block flex flex-row">
                          <feather-icon class="cursor-pointer" icon="FileTextIcon"
                                        svgClasses="text-darkgrey stroke-current h-4 w-4"/>
                          <span class="ml-2 font-semibold">{{ $t('class-over-view.pre-test') }}</span>
                        </span>
              <span class="text-2xl font-semibold block">
                {{unit.preTestExpectScore}}
              </span>
              <span>
                <small
                  class="text-grey activity-e-time">{{ $t('class-over-view.quiz') }}
                </small>
              </span>
            </p>
            <p class="text-center">
                        <span class="block flex flex-row">
                          <feather-icon class="cursor-pointer" icon="FilmIcon"
                                        svgClasses="text-darkgrey stroke-current h-4 w-4"/>
                          <span class="ml-2 font-semibold">{{ $t('class-over-view.e-class') }}</span>
                        </span>
              <span class="text-2xl font-semibold block">
                {{formatVdoLength(unit.seq)}}
              </span>
              <span>
                          <small class="text-grey activity-e-time">{{ $t('class-over-view.min') }}</small>
                        </span>
            </p>
            <p class="text-center">
                        <span class="block flex flex-row">
                          <feather-icon class="cursor-pointer" icon="FileTextIcon"
                                        svgClasses="text-darkgrey stroke-current h-4 w-4"/>
                          <span class="ml-2 font-semibold">{{ $t('class-over-view.post-test') }}</span>
                        </span>
              <span class="text-2xl font-semibold block">
                {{unit.postTestExpectScore}}
              </span>
              <span>
                <small class="text-grey activity-e-time">
                  {{ $t('class-over-view.quiz') }}
                </small>
              </span>
            </p>
          </div>

          <!--<div class="flex justify-between">

            <vs-button
              class="mr-2 shadow-lg card-button"
              color="#7367F0" gradient-color-secondary="#CE9FFC" type="gradient">
              <span>{{ $t('class-over-view.pre-test') }}</span>
            </vs-button>

            <vs-button
              class="mr-2 shadow-lg card-button"
              color="#7367F0" gradient-color-secondary="#CE9FFC" type="gradient">
              <span>{{ $t('class-over-view.enter-class') }}</span>
            </vs-button>

            <vs-button
              class="mr-2 shadow-lg card-button"
              color="#7367F0" gradient-color-secondary="#CE9FFC" type="gradient">
              <span>{{ $t('class-over-view.post-test') }}</span>
            </vs-button>

          </div>-->


          <vs-divider/>
        </li>
    </ul>

    <vs-popup :active.sync="popupActive" class="holamundo" :title="popUpTitle">
      <p>{{popUpContent}}</p>
    </vs-popup>

  </vx-card>

</template>

<script>
  import {secondToMMMFormat} from "@/utils/data";

  export default {
    props: {
      classRoom: Object
    },
    data() {
      return {
        popupActive: false,
        popUpTitle: '',
        popUpContent: '',
      }
    },
    computed: {
      courseOutlineUnits() {
        return this.classRoom ? this.classRoom.courseOutlineRegistration.courseOutline.courseOutlineUnits : []
      }
    },
    methods: {
      routeTo(route) {
        if (route) {
          this.$router.push(route);
        }
      },
      formatVdoLength(unitSeq) {
        if (this.classRoom) {
          let vdoSetUnit = this.classRoom.classSection.vdoSet.vdoSetUnits.find(item => item.unitSeq === unitSeq);
          if (vdoSetUnit) {
            return secondToMMMFormat(vdoSetUnit.totalVdoLength);
          }
        }
        return '-'
      },
      openPopUpClick(content, title){
        this.popUpTitle = title;
        this.popUpContent = content;
        this.popupActive = true;
      },
      navigateToVirtualClassExample(){
        this.$router.push({
          path: `/e-learning/virtual-class/${this.classRoom.classSection.id}`,
          params: {
            classSectionId: this.classRoom.classSection.id,
          }
        });
      },
    },
  }
</script>

<style lang="scss">
  @import "@/assets/scss/vuexy/components/vxTimeline.scss";

  .vs-card__actions {
    position: absolute;
    right: 24px;
  }

</style>
